export default __webpack_public_path__ + "static/media/empty.e05b30de.png";